import { RequestMVRFormFields } from './types';

export const requiredFields: (keyof RequestMVRFormFields)[] = [
  'date_of_birth',
  'default_mvr_provider',
  'drivers_license_number',
  'drivers_license_state',
  'first_name',
  'gender',
  'last_name',
];

export const OVERRIDE_PROVIDER_HELPER_TEXT = 'ⓘ Leave blank to use the default provider for this state.';
